import { createSlice } from '@reduxjs/toolkit';

const newsSlice = createSlice({
    name: 'news',
    initialState: {
        display: 'none',
        groupno: 1
    },
    reducers: {
        setDisplay: (state, action) => {
            state.display = action.payload.display;
        },
        setGroupNo: (state, action) => {
            state.groupno = action.payload.groupno;
        }
    }
});

export const { setDisplay, setGroupNo } = newsSlice.actions;
export default newsSlice.reducer;
